<form class="example-form">
  <mat-chip-list #chipList>
    <mat-chip style="margin-top:0.4em;" *ngFor="let option of this.cosyCommunicationControllerService.searchOption"
    (removed)="removeOption(option)">
    <span>{{option.displayName}}</span>
   <!-- <mat-icon matChipRemove>x</mat-icon> -->
   <mat-icon matChipRemove>close</mat-icon>
  </mat-chip>
    <input  #autocompleteInput (input)="reset(autocompleteInput.value)" (keydown.enter)="processSearchAction('')" 
    class='form-control form-control-sm'
    [value]="searchedTerm"      
    type="search"
    [placeholder]="placeholder"
    [formControl]="myControl" matInput
    aria-label="Number" 
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList">
   
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
      (onSelectionChange)="filterPostList($event)">
      {{option.displayName}}
    </mat-option>
    </mat-autocomplete>
      <button class="btn btn-light btn-sm" type="submit" (click)="processSearchAction('')">
        <i id="button_Search"></i>
      </button>
   </mat-chip-list>
  </form>


<!--<form class="example-form">
  <mat-form-field class="example-full-width">
    <mat-chip-list #chipList>
      <mat-chip style="margin-top:0.4em;" *ngFor="let option of this.cosyCommunicationControllerService.searchOption"
        (removed)="removeOption(option)">
        <span>{{option.displayName}}</span>
        <mat-icon matChipRemove>x</mat-icon>
      </mat-chip>
      <input #autocompleteInput (keydown.enter)="processSearchAction('')" 
      [value]="searchedTerm" type="text"
        [placeholder]="placeholder" aria-label="Number" matInput [formControl]="myControl" [matAutocomplete]="auto"
        [matChipInputFor]="chipList" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
          (onSelectionChange)="filterPostList($event)">
          {{option.displayName}}
        </mat-option>
      </mat-autocomplete>
    </mat-chip-list>
  </mat-form-field>
  <span class="input-group-btn">
    <button class="btn btn-light btn-sm" type="submit" (click)="processSearchAction('')">
      <i id="button_Search"></i>
    </button>
  </span>
</form>-->